// Точка входа Mini App: инициализация Telegram + i18n, hash-роутер и реестр экранов.
import './styles.css';
import { initTelegram, hideBackButton, hideMainButton, startParam } from './tg';
import { initLang } from './i18n';
import { trackAppOpen } from './services/track';
import { parseDeeplinkPayload } from './core/deeplink';
import { renderLaunch } from './screens/launch';
import { renderGames } from './screens/games';
import { renderGame } from './screens/game';
import { renderShared } from './screens/shared';
import { renderTrain } from './screens/train';
import { renderTrainBlunders } from './screens/train-blunders';
import { renderTrainOpenings } from './screens/train-openings';
import { renderMyGames, renderSharedMyGame } from './screens/my-games';
import { renderMyGamePlay } from './screens/my-game-play';

const app = document.getElementById('app')!;

function render(): void {
  const hash = location.hash || '#/';
  // Сбрасываем нативные кнопки Telegram — каждый экран выставит свои.
  hideBackButton();
  hideMainButton();

  if (hash.startsWith('#/s/')) {
    renderShared(app, hash.slice('#/s/'.length));
    return;
  }
  if (hash.startsWith('#/my/s/')) {
    renderSharedMyGame(app, hash.slice('#/my/s/'.length));
    return;
  }
  if (hash.startsWith('#/game/')) {
    const id = decodeURIComponent(hash.slice('#/game/'.length).split('?')[0]!);
    renderGame(app, id);
    return;
  }
  if (hash.startsWith('#/train/blunders')) {
    renderTrainBlunders(app);
    return;
  }
  if (hash.startsWith('#/train/openings')) {
    renderTrainOpenings(app);
    return;
  }
  if (hash === '#/train/my/new') {
    renderMyGamePlay(app);
    return;
  }
  if (hash === '#/train/my') {
    renderMyGames(app);
    return;
  }
  if (hash === '#/train') {
    renderTrain(app);
    return;
  }
  if (hash === '#/games') {
    renderGames(app);
    return;
  }
  renderLaunch(app);
}

initTelegram();
initLang();

// Диплинк на конкретную партию (startapp) — открываем чужой разбор и метим виральность.
const deeplink = startParam();
const myShared = deeplink?.match(/^my_([A-Za-z0-9]{8,12})$/)?.[1];
const sharedOpen = Boolean(deeplink && (parseDeeplinkPayload(deeplink) || myShared) && !location.hash.startsWith('#/game/'));
trackAppOpen(sharedOpen);
if (myShared) location.hash = `#/my/s/${myShared}`;
else if (sharedOpen) location.hash = `#/s/${deeplink}`;

window.addEventListener('hashchange', render);

if (!location.hash) location.hash = '#/';
render();
